// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_lw-5";
export var filledCircle = "_lw-4";
export var historyEntry = "_lw-3";
export var messageSideLeft = "_lw-1";
export var messageSideRight = "_lw-2";
export var orderTrackingCarouselWrapper = "_lw-6";
export var orderTrackingInfoContainer = "_lw-0";